import React from 'react';
import { CollectionItem } from '../../types';
import VersionsDropdown from './VersionDropdown';

interface Props {
  content: CollectionItem;
}

const CollectionTile = ({ content }: Props) => {
  const url = () => {
    if (content.type === 'docSpace') {
      return `/${content.content}`;
    }

    if (content.type === 'externalUrl') {
      return content.content;
    }

    return '#';
  };
  return (
    <div className="tile collection-tile">
      <a href={url()} className="tile-content">
        <div className="tile-title">{content.title}</div>
        {content.type === 'docSpace' && !!content.versions?.length && (
          <VersionsDropdown
            position={content.nestedPosition || content.position?.toString()}
            selectedVersion={content.content}
            versions={content.versions}
          />
        )}
        <p className="ellipsis-4-lines hide-mobile">{content.description}</p>
      </a>
    </div>
  );
};

export default CollectionTile;
